
export function json(url, callback = () => {}) {
	if (!url) callback(null)
	const request = new XMLHttpRequest()
	request.addEventListener('readystatechange', event => {
		if (request.readyState !== 4) return
	    if (request.status == 200) return callback(JSON.parse(request.responseText))
		return callback(null)
	})
    request.open("GET", url, true)
    request.send(null)
}